module.exports = {
  SWITCH_LANGUAGE: 'SWITCH_LANGUAGE',
  TOGGLE_MENU: 'TOGGLE_MENU'
};



// WEBPACK FOOTER //
// ./src/action-types.js